// Module Federation bootstrap file
// This file initializes shared dependencies before loading the app
import('./main');
export {};
